import React from "react";
import { SectionHeader } from "./SectionHeader";

export const Recipient = ({ data }) => {
  if (!data) return <div id="recipient">loading...</div>;

  return (
    <div id="recipient" className="py-5">
      <SectionHeader />
      <div className="container">
        {/* Überschrift */}
        <div className="section-title text-center mb-4">
          <h2 className="rules-title">{data.title}</h2>
        </div>

        {/* Inhalt als Absätze */}
        <div className="recipient-text text-center">
          {data.text.split("\n").map((para, idx) => (
            <p key={idx}>{para.trim()}</p>
          ))}
        </div>
      </div>
            <SectionHeader  />
 <div className="section-title text-center mb-4">
          <h2 className="rules-title">{data.projectPartnerTitle}</h2>
        </div>
      <div className="recipient-text text-center">
        {data.projectPartnerText.split("\n").map((para, idx) => (
          <p key={idx}>{para.trim()}</p>
        ))}
        <p>
    <a
      href="https://querkopf-akademie.de/"
      target="_blank"
      rel="noopener noreferrer"
    >
      🌐 Website
    </a>
  </p>
      </div>
      
    </div>
  );
};